/**
 * Eventos de dominio y avisos (F4.1, NOTIF-01, plan maestro §9.3 y §18.3).
 *
 * Un evento solo se publica si su tipo esta aqui, con su version: asi un
 * consumidor sabe que forma tiene lo que recibe y un tipo mal escrito falla al
 * publicar, no en silencio.
 */
export const VERSION_DE_EVENTO = {
    'archivo.disponible': 1,
    'archivo.rechazado': 1,
    'resultado.publicado': 1,
    'resultado.retirado': 1,
    // F4.8: el equipo respondio en una conversacion.
    'mensaje.respondido': 1,
    // F5.3: el consultorio cruzo un umbral de su cuota.
    'cuota.umbral': 1,
};
export const TIPOS_DE_EVENTO = Object.keys(VERSION_DE_EVENTO);
export function esTipoDeEvento(valor) {
    return Object.hasOwn(VERSION_DE_EVENTO, valor);
}
/** Canales de aviso. SMS y push existen como adaptadores sin proveedor (S-05). */
export const CANALES_DE_AVISO = ['correo', 'sms', 'push'];
export const NOMBRE_DE_CANAL = {
    correo: 'Correo',
    sms: 'SMS',
    push: 'Notificación en el teléfono',
};
/**
 * Texto de cada aviso. NEUTRO por regla (§9.3): nunca un diagnostico, un valor,
 * el nombre de un estudio ni un enlace con acceso duradero. Abrir el contenido
 * exige entrar al portal con sesion. El nombre del consultorio sale de su
 * marca: aqui no hay ninguno.
 */
export const PLANTILLAS_DE_AVISO = {
    'actualizacion-portal': {
        asunto: (consultorio) => `${consultorio}: tiene una actualización`,
        cuerpo: (consultorio) => `Tiene una actualización de ${consultorio}. Para verla, entre a su portal con su cuenta.`,
    },
};
export const ESTADOS_DE_AVISO = ['pendiente', 'enviado', 'omitido', 'fallido'];
//# sourceMappingURL=eventos.js.map